import { Box, Typography } from '@mui/material'
import { OrderResponseDto } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { documentsService } from '@planning/services'
import { formatDate, openFileInNewWindow } from '@planning/utils'
import { useTranslate } from '@tolgee/react'
import { Loader, PdfDocumentIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

export interface IEirDocumentProps {
  order: OrderResponseDto
}

export const EirPdfDocument: FC<IEirDocumentProps> = observer(({ order }) => {
  const { appViewStore } = usePlanningStore()
  const { t } = useTranslate()

  if (!order.eirPdfUrl) return <></>

  function extractFileName(url: string) {
    try {
      const decodedUrl = decodeURIComponent(url)
      const match = decodedUrl.match(/(Eir_.+?\.pdf)/)
      return match ? match[1] : null
    } catch (error) {
      console.error('Invalid URL:', error)
      return null
    }
  }

  const fileName = extractFileName(order.eirPdfUrl)

  if (!fileName?.length) return <></>

  const handleClick = async () => {
    try {
      appViewStore.showLoader()

      const document = await documentsService.downloadEirDocument(fileName)
      openFileInNewWindow(document)
    } catch (error) {
      appViewStore.setShowAlert(
        'error',
        t('errorDownloadingDocument', 'Error downloading the document'),
      )
    } finally {
      appViewStore.hideLoader()
    }
  }

  return (
    <Box display='flex' alignItems='center' onClick={handleClick} sx={{ cursor: 'pointer' }}>
      {appViewStore.isLoading && <Loader show />}
      <Box
        minWidth={'40px'}
        minHeight={'40px'}
        display='flex'
        alignItems='center'
        justifyContent='stretch'
      >
        <PdfDocumentIcon sx={{ height: '100%', width: '100%' }} />
      </Box>
      <Box>
        <Typography variant='subtitle2'>{fileName}</Typography>
        <Typography variant='caption'>{formatDate(order.eirPdfCreatedAt, 'short')}</Typography>
      </Box>
    </Box>
  )
})
